interface SeverityPillProps {
  severityCode: number
  label: string
  className?: string
}

export default function SeverityPill({ severityCode, label, className = '' }: SeverityPillProps) {
  const baseClass = 'py-1 px-2 rounded-full'

  const severityClasses =
    severityCode === 1
      ? 'bg-[#6AC380] text-[#2e2f2f]'
      : severityCode === 2
        ? 'bg-[#ffcf3e] text-warning-content'
        : severityCode === 3
          ? 'bg-[#F18484] text-error-content'
          : ''

  return <span className={`${baseClass} ${severityClasses} ${className}`}>{label}</span>
}
